import { BarChart } from '@mui/x-charts/BarChart';

function Bar({label, data}) {
    return (
        <BarChart
            xAxis={[
                {
                id: 'barCategories',
                data: label,
                tickLabelStyle: { fill: 'white' },
                },
            ]}
            series={[
                {
                data: data,
                },
            ]}
            height={300}
            borderRadius={10}
            barLabel="value"
            margin={{ left: -1, right : -1, top:0, bottom : 0 }}
            yAxis={[
                {
                width: 0,
                tickLabelStyle: { fill: 'white' },
                },
            ]}
        />
    )
}

export default Bar